<template>
  <div class="stran-brez-izbirnika pregled-vsebine">
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <p class="open-sans-30pt">
          Urejanje T-2 identitete
        </p>
        <div style="padding-top: 20px">
          <el-tabs type="border-card" @tab-click="HandleTabClick" value="t1">
            <el-tab-pane label="Osebni podatki" name="t1" ref="t1">
              <OsebniPodatki v-on:datumRojstva="PreracunStarosti"/>
            </el-tab-pane>
<!--            <el-tab-pane label="Soglasja" name="t2" ref="t2" v-if="this.prenosniRojstniDatum !== null &&-->
<!--             this.prenosniRojstniDatum > 15">-->
<!--              <SoglasjaProfil />-->
<!--            </el-tab-pane>-->
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {SirinaOkna} from 'src/assets/js/globalne_funkcije/SirinaOkna.js'
  import {Tabs, TabPane} from 'element-ui'
  import OsebniPodatki from './UrejanjeProfila/OsebniPodatki'
  import SoglasjaProfil from './UrejanjeProfila/SoglasjaProfil'
  export default {
    name: 'Osnovno',
    data () {
      return {
        prenosniRojstniDatum: null
      }
    },
    mixins: [SirinaOkna],
    watch: {
      orientacija: function (val) {
        this.formaOrientacija = val
      }
    },
    components: {
      'SoglasjaProfil': SoglasjaProfil,
      'OsebniPodatki': OsebniPodatki,
      [Tabs.name]: Tabs,
      [TabPane.name]: TabPane
    },
    methods: {
      PreracunStarosti (starost) {
        if (starost !== null) {
          let currentTime = new Date().getTime()
          let birthDateTime = new Date(starost).getTime()
          let difference = (currentTime - birthDateTime)
          let ageInYears = difference / (1000 * 60 * 60 * 24 * 365)
          this.prenosniRojstniDatum = Math.round(ageInYears)
        }
      },
      HandleTabClick (tab) {
        this.activetab = tab.name
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/Osnovno.vue